import { Checkbox } from 'antd';
import styled, { css } from 'styled-components';
import color from '../../configs/color';

const Item = styled(Checkbox)`
  display: inline-flex;
  width: 100% !important;
  min-width: fit-content;
  margin: 0 !important;
  border-radius: 12px;
  &.component_placements {
    padding: 14px 28px 14px 44px;
    border-radius: 0;
    display: flex;
    flex-direction: row-reverse;
    > span:last-child {
      margin-right: auto;
    }
    :hover {
      background-color: ${color.grey3};
    }
  }
  &.with_border {
    height: 44px !important;
    border-radius: 12px !important;
    border: 1px solid ${color.grey1};
    font-size: 16px;
    padding: 0 12px;
    line-height: 44px;
  }
`;

const Group = styled(Item.Group)`
  display: ${(props) => {
    return props.block ? 'block' : 'flex';
  }};

  ${(props) => {
    return (
      props.columnCount &&
      css`
        -webkit-column-count: ${props.columnCount};
        -moz-column-count: ${props.columnCount};
        column-count: ${props.columnCount};
      `
    );
  }}
  ${(props) => {
    return (
      props.columnGap &&
      css`
        -webkit-column-gap: ${props.columnGap};
        -moz-column-gap: ${props.columnGap};
        column-gap: ${props.columnGap};
      `
    );
  }}

  ${(props) => {
    return (
      props.block &&
      css`
        > * {
          margin-bottom: ${props.rowGap}px !important;
        }
      `
    );
  }}
`;

export default { Item, Group };
